import Skeleton from '@discover-ui/skeleton';
import { RestaurantRatingSkeleton } from '@discover-components/restaurant/rating';
import Root, { type RootProps } from './root';

export default function RestaurantCardTitleRowSkeleton(props: Omit<RootProps, 'children'>) {
  return (
    <Root {...props}>
      <Skeleton
        as="h3"
        className="mb-0 mr-auto text-[16px] font-semibold leading-[22px] tracking-normal md:text-[24px] md:leading-[32px]">
        Loading Restaurant...
      </Skeleton>
      <RestaurantRatingSkeleton className="hidden leading-tight md:flex" />
    </Root>
  );
}
